import {getToken, removeToken} from "@/utils/auth";
import {
    checkLogin,
    forgetPwd,
    forgetTkPwd,
    getChatUnread,
    getInfo,
    getUserLevel,
    getUserMoney,
    getUserPlanGroupInfo,
    login,
    loginGuest,
    logout,
    register
} from "@/api/user";
import websocketUtil from "@/utils/socket/websocketUtil";
import {
    user_getUserInfo,
    user_getUserLevel,
    user_getUserMoney,
    user_getUserNoticeNum,
    user_receiveChatGroupRecord,
    user_readChatGroupRecords,
} from "@/utils/socket/websocketKeys";
// import Cookies from "js-cookie";
import {add2Cart, delCart, getCartList, updateById} from "@/api/user.cart";
import {
    addToWishList,
    deleteFromWishList,
    getWishList
} from "@/api/user.storeGoodsUserWish";
import {
    addToCompareList,
    deleteAllFromCompareList,
    deleteFromCompareList,
    getCompareList
} from "@/api/user.storeGoodsUserCompare";
import {getNoticeList, getNoticeNoReadNum} from "@/api/sys/info";

const state = {
    userInfo: {},
    userMoney: {},
    userLevel: {},
    popPicInfo: {},
    userCart: [],
    wishList: [],
    compareList: [],
    rankList: [],
    noticeList: [],
    chatUnread: 0,
    chatGroupLastChange: {},
    chatGroupRecord: {},
};

const mutations = {
    change_chatUnread: (state, changeNum) => {
        state.chatUnread = Math.max(state.chatUnread + changeNum, 0);
    },
    SET_chatGroupLastChange: (state, chatGroupLastChange) => {
        state.chatGroupLastChange = chatGroupLastChange;
    },
    SET_chatGroupRecord: (state, chatGroupRecord) => {
        state.chatGroupRecord = chatGroupRecord;
    },
    SET_ACCOUNT: (state, userInfo) => {
        state.userInfo = userInfo || {};
    },
    UPDATE_ACCOUNT: (state, userInfo) => {
        Object.assign(state.userInfo, userInfo);
    },
    SET_USER_MONEY: (state, userMoney) => {
        state.userMoney = userMoney || {};
    },
    SET_USER_LEVEL: (state, userLevel) => {
        state.userLevel = userLevel || {};
    },
    SET_USER_POP_PIC: (state, picInfo) => {
        state.popPicInfo = picInfo || {};
    },
    SET_USER_CART: (state, userCart) => {
        state.userCart = userCart || [];
    },
    SET_WISH_LIST: (state, wishlist) => {
        state.wishList = wishlist || [];
    },
    SET_COMPARE_LIST: (state, compareList) => {
        state.compareList = compareList || [];
    },
    SET_NOTICE_NUM: (state, num) => {
        state.noticeNum = num || 0
    },
    SET_noticeList: (state, list) => {
        state.noticeList = list
    },
};

const actions = {
    getNoticeList: async ({commit}) => {
        commit('SET_noticeList', (await getNoticeList()).data)
    },
    async getUserNoticeNum({commit, dispatch, state}) {
        const num = (await getNoticeNoReadNum()).data
        commit('SET_NOTICE_NUM', num)
        return num
    },
    login({dispatch}, loginForm) {
        return new Promise((resolve, reject) => {
            login(loginForm)
                .then(res => {
                    let userInfo = res.data;
                    // dispatch("getLevelList");
                    dispatch("initSocket");
                    dispatch("getChatUnread");
                    dispatch("getUserInfo");
                    dispatch("getUserMoney");
                    dispatch("getUserLevel");
                    dispatch("getUserCart");
                    dispatch("getWishList");
                    dispatch("getCompareList");
                    resolve(userInfo);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    register({dispatch}, userInfo) {
        return new Promise((resolve, reject) => {
            register(userInfo)
                .then(() => {
                    dispatch("getUserInfo");
                    dispatch("getUserMoney");
                    dispatch("getUserLevel");
                    dispatch("initSocket");
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    forgetPwd(_, data) {
        return new Promise((resolve, reject) => {
            forgetPwd(data)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    forgetTkPwd(_, data) {
        return new Promise((resolve, reject) => {
            forgetTkPwd(data)
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    async checkLogin() {
        if (getToken()) {
            return (await checkLogin()).isLogin;
        }
        return false;
    },
    // 获取用户信息
    async getUserInfo({commit}) {
        const userInfo = (await getInfo()).data;
        Cookies.set("isShopOwner", userInfo.userShopId ? "1" : "0");
        commit("SET_ACCOUNT", userInfo);
        return userInfo;
    },
    // 获取用户金额信息
    async getUserMoney({commit}) {
        const userMoney = (await getUserMoney()).data;
        commit("SET_USER_MONEY", userMoney);
        return userMoney;
    },
    // 获取用户等级信息
    async getUserLevel({commit}) {
        const userLevel = (await getUserLevel()).data;
        commit("SET_USER_LEVEL", userLevel);
        return userLevel;
    },
    // 加载用户方案组信息
    async getUserPlanGroupInfo() {
        return await getUserPlanGroupInfo();
    },

    async getChatUnread({commit}) {
        const res = await getChatUnread();
        commit("change_chatUnread", res.data || 0);
        return res.data;
    },
    async getUserCart({commit}) {
        const res = await getCartList();
        commit("SET_USER_CART", res.data);
        return res.data;
    },
    async addToCart({dispatch}, cartItemData) {
        await add2Cart(cartItemData);
        await dispatch("getUserCart");
    },
    async deleteFromCart({state}, id) {
        await delCart(id);
        const shops = state.userCart;
        for (let i = 0; i < shops.length; i++) {
            const shop = shops[i];
            let carts = shop.carts;
            for (let j = 0; j < carts.length; j++) {
                let cart1 = carts[j];
                if (cart1.id === id) {
                    carts.remove(cart1)
                    if (carts.length === 0) {
                        shops.splice(i, 1);
                    }
                    break
                }
            }
        }
        console.log('shops', shops)
    },
    async updateCartItem({dispatch, commit}, cartItem) {
        await updateById(cartItem);
    },

    async getWishList({commit}) {
        const res = await getWishList();
        commit("SET_WISH_LIST", res.data.records);
        return res.data;
    },
    async addToWishList({dispatch, state}, itemData) {
        if (
            state.wishList.find(
                item =>
                    item.goodsId === itemData.goodsId && item.shopId === itemData.shopId
            )
        ) {
            return;
        }
        await addToWishList(itemData);
        await dispatch("getWishList");
    },
    async deleteFromWishList({state}, id) {
        await deleteFromWishList(id);
        const index = state.wishList.findIndex(item => item.id === id);
        if (index > -1) {
            state.wishList.splice(index, 1);
        }
    },

    async getCompareList({commit}) {
        const res = await getCompareList();
        commit("SET_COMPARE_LIST", res.data.records);
        return res.data;
    },
    async addToCompareList({dispatch, state}, itemData) {
        if (
            state.compareList.find(
                item =>
                    item.goodsId === itemData.goodsId && item.shopId === itemData.shopId
            )
        ) {
            return;
        }
        await addToCompareList(itemData);
        await dispatch("getCompareList");
    },
    async deleteFromCompareList({state}, id) {
        await deleteFromCompareList(id);
        const index = state.compareList.findIndex(item => item.id === id);
        if (index > -1) {
            state.compareList.splice(index, 1);
        }
    },
    async deleteAllFromCompareList({state}) {
        await deleteAllFromCompareList();
        state.compareList = [];
    },

    setUserPopPic({commit}, pic_info) {
        commit("SET_USER_POP_PIC", pic_info);
    },
    // 登出
    logout({commit, dispatch}) {
        return new Promise((resolve, reject) => {
            logout()
                .then(async () => {
                    await dispatch("logoutFront");
                    resolve();
                    // location.reload();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    logoutFront({commit}) {
        websocketUtil.methods.disconnect();
        commit("SET_ACCOUNT", null);
        commit("SET_USER_MONEY", null);
        commit("SET_USER_LEVEL", null);
        removeToken();
    },
    // 登录
    async initSocket({commit, dispatch}) {
        console.debug(`initSocket disconnect before`);
        await websocketUtil.methods.disconnect();
        console.debug(`initSocket disconnect after`);
        let subGetUser = [
            {
                topic: user_receiveChatGroupRecord,
                topicFn: data => {
                    console.debug(`收到 receiveChatGroupRecord 消息:${data.body}`);
                    let group = JSON.parse(data.body);
                    let record = JSON.parse(group.lastMessageSimpleJson);
                    // 消息撤回
                    if (group.rollbackFlag) {
                        // 已读
                        let readFlag = !group.lastReadId || parseInt(group.lastReadId) < record.id
                        if (readFlag) {
                            commit('change_chatUnread', -1)
                        }
                    }
                    // 新增消息
                    else {
                        commit('change_chatUnread', 1)
                    }
                    // if (parseInt(record.id) >= parseInt(group.lastMessageId||0)) {
                    //
                    // }
                    commit('SET_chatGroupLastChange', group)
                    commit('SET_chatGroupRecord', record)
                }
            },
            {
                topic: user_readChatGroupRecords,
                topicFn: data => {
                    console.debug(`收到 readChatGroupRecords 消息:${data.body}`);
                    commit('change_chatUnread', -parseInt(data.body))
                }
            },
            {
                topic: user_getUserInfo,
                topicFn: data => {
                    console.debug(`收到getUserInfo消息:${data.body}`);
                    dispatch("getUserInfo");
                }
            },
            {
                topic: user_getUserMoney,
                topicFn: data => {
                    console.debug(`收到getUserMoney消息:${data.body}`);
                    dispatch("getUserMoney");
                }
            },
            {
                topic: user_getUserLevel,
                topicFn: data => {
                    console.info(`收到getUserLevel消息`);
                    commit("SET_USER_LEVEL", JSON.parse(data.body));
                }
            },
            {
                topic: user_getUserNoticeNum,
                topicFn: (data) => {
                    console.log(`收到user_getUserNoticeNum消息:`, data)
                    const num = parseInt(JSON.parse(data.body))
                    commit('SET_NOTICE_NUM', state.noticeNum + num)
                }
            }
        ];
        return websocketUtil.methods.connect(subGetUser);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
